import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OrganizationEnergieApiService } from '@_services/api/organization-energie-api.service';
import { AppState } from '@_store/index.reducers';
import { GeneratedOrganizationEnergieEffects } from './organization-energie-generated.effects';

@Injectable()
export class OrganizationEnergieEffects extends GeneratedOrganizationEnergieEffects {
  constructor(
    actions$: Actions,
    organizationEnergieApiService: OrganizationEnergieApiService,
    store$: Store<AppState>
  ) {
    super(actions$, organizationEnergieApiService, store$);
  }
}
